import React, { useState, useRef, useEffect } from "react";
import { Link } from "gatsby";
import { Container } from "react-bootstrap";

const TailwindHeader = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [boardsDropdown, setBoardsDropdown] = useState(false);
  const [compareDropdown, setCompareDropdown] = useState(false);

  const boardsDropdownRef = useRef(null);
  const compareDropdownRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", event => {
      if (
        boardsDropdownRef.current &&
        !boardsDropdownRef.current.contains(event.target) &&
        event.target.id !== "boards-dropdown-btn" &&
        event.target.id !== "boards-dropdown-btn-sm"
      ) {
        // console.log("you clicked outside");
        // console.log(event.target.id);
        setBoardsDropdown(false);
      }
    });
  }, [boardsDropdownRef]);

  useEffect(() => {
    document.addEventListener("mousedown", event => {
      if (
        compareDropdownRef.current &&
        !compareDropdownRef.current.contains(event.target) &&
        event.target.id !== "compare-dropdown-btn" &&
        event.target.id !== "compare-dropdown-btn-sm"
      ) {
        // console.log("you clicked outside");
        // console.log(event.target.id);
        setCompareDropdown(false);
      }
    });
  }, [compareDropdownRef]);

  const linkClasses =
    "block px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-indigo-800 focus:outline-none focus:text-white focus:bg-indigo-800 transition duration-150 ease-in-out";

  return (
    <nav className="bg-indigo-700 px-3">
      <Container>
        <div className="flex items-center justify-between w-full h-16">
          <div className="flex items-center sm:hidden mr-10">
            <button
              className="h-10 w-10 flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-indigo-800 focus:outline-none focus:bg-indigo-800 focus:text-white transition duration-150 ease-in-out"
              onClick={() => setOpenMenu(!openMenu)}
              aria-label="Main menu"
              aria-expanded="false"
            >
              {(!openMenu && (
                <i className="text-lg align-middle fa fa-bars"></i>
              )) || <i className="text-lg align-middle fa fa-times"></i>}
            </button>
          </div>
          <div className="flex-1 flex items-center justify-start">
            <div className="mr-6">
              <Link
                className="block sm:hidden w-auto text-white text-4xl font-black focus:outline-none focus:shadow-outline"
                id="site-brand"
                to="/"
              >
                Electr
                <span className="text-secondary-light text-sm">.tech</span>
              </Link>
              <Link
                className="hidden sm:block w-auto text-white text-4xl font-black focus:outline-none focus:shadow-outline"
                id="site-brand"
                to="/"
              >
                Electr
                <span className="text-secondary-light text-sm">.tech</span>
              </Link>
            </div>

            <div className="hidden sm:flex items-center">
              <div className="flex justify-center">
                <Link to="/" className={`${linkClasses}`}>
                  Home
                </Link>
                <Link to="/blog" className={`${linkClasses}`}>
                  Blog
                </Link>
                <div className="relative">
                  <button
                    onClick={() => setBoardsDropdown(!boardsDropdown)}
                    className={`${linkClasses}`}
                    aria-expanded="true"
                    id="boards-dropdown-btn"
                  >
                    Boards <i className="fa fa-caret-down" />
                  </button>
                  {boardsDropdown && (
                    <ul
                      className="absolute origin-top-left w-48 shadow-md bg-white z-30 rounded-md overflow-hidden transition ease-in-out duration-150"
                      aria-orientation="vertical"
                      aria-labelledby="boards-menu"
                      ref={boardsDropdownRef}
                    >
                      <li>
                        <Link
                          to="/microcontrollers"
                          className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                        >
                          Microcontrollers
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/single-board-computers"
                          className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                        >
                          Single-board Computers
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
                <div className="relative">
                  <button
                    onClick={() => setCompareDropdown(!compareDropdown)}
                    className={`${linkClasses}`}
                    aria-expanded="true"
                    id="compare-dropdown-btn"
                  >
                    Compare <i className="fa fa-caret-down" />
                  </button>
                  {compareDropdown && (
                    <ul
                      className="absolute origin-top-left w-48 shadow-md bg-white z-30 rounded-md overflow-hidden transition ease-in-out duration-150"
                      aria-orientation="vertical"
                      aria-labelledby="boards-menu"
                      ref={compareDropdownRef}
                    >
                      <li>
                        <Link
                          to="/compare/microcontrollers"
                          className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                        >
                          Microcontrollers
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/compare/single-board-computers"
                          className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                        >
                          Single-board Computers
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
                <Link to="/about" className={`${linkClasses}`}>
                  About
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="block sm:hidden">
          {openMenu && (
            <div className="pt-2 pb-3">
              <Link to="/" className={`${linkClasses}`}>
                Home
              </Link>
              <Link to="/blog" className={`${linkClasses}`}>
                Blog
              </Link>
              <div className="relative">
                <button
                  onClick={() => setBoardsDropdown(!boardsDropdown)}
                  className={`${linkClasses} w-full text-left flex justify-between`}
                  aria-expanded="true"
                  id="boards-dropdown-btn-sm"
                >
                  Boards <i className="fa fa-caret-down" />
                </button>
                {boardsDropdown && (
                  <ul
                    className="absolute origin-top-right w-full shadow-md bg-white z-30 rounded-md overflow-hidden transition ease-in-out duration-150"
                    aria-orientation="vertical"
                    aria-labelledby="boards-menu"
                    ref={boardsDropdownRef}
                  >
                    <li>
                      <Link
                        to="/microcontrollers"
                        className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                      >
                        Microcontrollers
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/single-board-computers"
                        className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                      >
                        Single-board Computers
                      </Link>
                    </li>
                  </ul>
                )}
              </div>
              <div className="relative">
                <button
                  onClick={() => setCompareDropdown(!compareDropdown)}
                  className={`${linkClasses} w-full text-left flex justify-between`}
                  aria-expanded="true"
                  id="compare-dropdown-btn-sm"
                >
                  Compare <i className="fa fa-caret-down" />
                </button>
                {compareDropdown && (
                  <ul
                    className="absolute origin-top-right w-full shadow-md bg-white z-30 rounded-md overflow-hidden transition ease-in-out duration-150"
                    aria-orientation="vertical"
                    aria-labelledby="boards-menu"
                    ref={compareDropdownRef}
                  >
                    <li>
                      <Link
                        to="/compare/microcontrollers"
                        className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                      >
                        Microcontrollers
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/compare/single-board-computers"
                        className="block text-gray-700 leading-5 text-sm px-4 py-3 hover:bg-gray-300 focus:outline-none focus:bg-gray-300"
                      >
                        Single-board Computers
                      </Link>
                    </li>
                  </ul>
                )}
              </div>
              <Link to="/about" className={`${linkClasses}`}>
                About
              </Link>
            </div>
          )}
        </div>
      </Container>
    </nav>
  );
};

export default TailwindHeader;
